import { OrderDto } from '../../dto/order.dto';

export enum OrderEventType {
    NEW_PREORDER = 'NEW_PREORDER',
    NEW_ORDER = 'NEW_ORDER',
    ORDER_ACCEPTED = 'ORDER_ACCEPTED',
    ORDER_IN_PROGRESS = 'ORDER_IN_PROGRESS',
    ORDER_READY = 'ORDER_READY',
    ORDER_IN_TRANSIT = 'ORDER_IN_TRANSIT',
    ORDER_DELIVERED = 'ORDER_DELIVERED',
    ORDER_CANCELLED = 'ORDER_CANCELLED',
    ORDER_SEQUENCED = 'ORDER_SEQUENCED',
    GENERIC_EVENT = 'GENERIC_EVENT'
}

export enum OrderEventDescription {
    NEW_PREORDER = 'Order #${0} has been successfully placed as a preorder',
    NEW_ORDER = '"Order #${0} has been successfully placed',
    ORDER_ACCEPTED = 'Order #${0} has been accepted',
    ORDER_IN_PROGRESS = 'Order #${0} is now in progress',
    ORDER_READY = 'Order #${0} is ready',
    ORDER_IN_TRANSIT = 'Order #${0} is now in transit',
    ORDER_DELIVERED = 'Order #${0} has been successfully delivered',
    ORDER_CANCELLED = 'Order #${0} has been cancelled.',
    ORDER_SEQUENCED = 'ORDER_SEQUENCED',
    GENERIC_EVENT = 'GENERIC_EVENT'
}

export class OrderEvent {
    orders?: OrderDto[];
    eventType: OrderEventType = OrderEventType.GENERIC_EVENT;
    description?: string;
    sequenceIndex?: number = -1;
}